<template>
<div>
  <vx-card title="价格计算公式" class="mb-5">
    <p class="text-warning">
      普通用户： [(二维码价格 * 标签材质价格系数) + 二维码有效期单价 + 普通用户二维码单价] * 数量
    </p>
    <p class="text-primary">
      渠道商： [(二维码价格 * 标签材质价格系数) + 渠道商二维码单价] * 数量
    </p>
  </vx-card>
  <vx-card title="普通用户二维码价格" class="mb-5">
    <b class="text-danger">注：最大值为0表示无穷大</b>
    <vs-table :data="qr">
      <template slot="thead">
        <vs-th>
          最小值
        </vs-th>
        <vs-th>
          最大值
        </vs-th>
        <vs-th>
          单价（元）
        </vs-th>
        <vs-th>
          操作
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td>
            <vx-input v-model="data[i].min" :beforeValue="v => Number(v)" />
          </vs-td>

          <vs-td>
            <vx-input v-model="data[i].max" :beforeValue="v => Number(v)" />
          </vs-td>

          <vs-td>
            <vx-input v-model="data[i].price" :beforeValue="v => Number(v)" />
          </vs-td>

          <vs-td>
           <a class="cursor-pointer text-danger" @click="data.splice(i, 1)">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="primary" class="mt-2 mr-2" @click="savePrice">保存设置</vs-button>
    <vs-button type="border" color="primary" class="mt-2" @click="addQrPrice">新增</vs-button>
  </vx-card>

  <vx-card title="渠道商二维码价格" class="mb-5">
    <b class="text-danger">注：最大值为0表示无穷大</b>
    <vs-table :data="channelQr">
      <template slot="thead">
        <vs-th>
          最小值
        </vs-th>
        <vs-th>
          最大值
        </vs-th>
        <vs-th>
          单价（元）
        </vs-th>
        <vs-th>
          操作
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td>
            <vx-input v-model="data[i].min" :beforeValue="v => Number(v)" />
          </vs-td>

          <vs-td>
            <vx-input v-model="data[i].max" :beforeValue="v => Number(v)" />
          </vs-td>

          <vs-td>
            <vx-input v-model="data[i].price" :beforeValue="v => Number(v)" />
          </vs-td>

          <vs-td>
            <a class="cursor-pointer text-danger" @click="data.splice(i, 1)">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="primary" class="mt-2 mr-2" @click="savePrice">保存设置</vs-button>
    <vs-button type="border" color="primary" class="mt-2" @click="() => channelQr.push({
        min: '',
        max: '',
        price: '',
      })">新增</vs-button>
  </vx-card>

  <vx-card title="二维码有效期" class="mb-5">
    <vs-table :data="qrExpire">
      <template slot="thead">
        <vs-th>
          时长(0表示长期)
        </vs-th>
        <vs-th>
          单价（元）
        </vs-th>
        <vs-th>
          操作
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td class="whitespace-no-wrap">
            <vx-input class="inline-block w-12" :beforeValue="v => Number(v)" v-model="data[i].years" />年
          </vs-td>
          <vs-td>
            <vx-input v-model="data[i].price" :beforeValue="v => Number(v)" />
          </vs-td>
          <vs-td>
            <a class="cursor-pointer text-danger" @click="data.splice(i, 1)">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="primary" class="mt-2 mr-2" @click="savePrice">保存设置</vs-button>
    <vs-button type="border" color="primary" class="mt-2" @click="() => qrExpire.push({
        id: Math.max(...qrExpire.map(i => i.id)) + 1,
        years: '',
        name: '',
        price: '',
      })">新增</vs-button>
  </vx-card>

  <vx-card title="标签材质" class="mb-5">
    <vs-table :data="material">
      <template slot="thead">
        <vs-th>
          材质
        </vs-th>
        <vs-th>
          价格系数
        </vs-th>
        <vs-th>
          操作
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td class="whitespace-no-wrap">
            <vx-input :beforeValue="v => Number(v)" v-model="data[i].name" />
          </vs-td>
          <vs-td>
            <vx-input v-model="data[i].price" :beforeValue="v => Number(v)" />
          </vs-td>
          <vs-td>
            <a class="cursor-pointer text-danger" @click="data.splice(i, 1)">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="primary" class="mt-2 mr-2" @click="savePrice">保存设置</vs-button>
    <vs-button type="border" color="primary" class="mt-2" @click="() => material.push({
        id: Math.max(...material.map(i => i.id)) + 1,
        name: '',
        price: '',
      })">新增</vs-button>
  </vx-card>

  <vx-card title="标签尺寸价格" class="mb-5">
    <vs-table :data="sticky">
      <template slot="thead">
        <vs-th>
          尺寸
        </vs-th>
        <vs-th>
          单价（元）
        </vs-th>
        <vs-th>
          操作
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td class="whitespace-no-wrap">
            <vx-input class="inline-block w-12" :beforeValue="v => Number(v)" v-model="data[i].width" />CM *
            <vx-input class="inline-block w-12" :beforeValue="v => Number(v)" v-model="data[i].height" />CM
          </vs-td>
          <vs-td>
            <vx-input v-model="data[i].price" :beforeValue="v => Number(v)" />
          </vs-td>
          <vs-td>
            <a class="cursor-pointer text-danger" @click="data.splice(i, 1)">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="primary" class="mt-2 mr-2" @click="savePrice">保存设置</vs-button>
    <vs-button type="border" color="primary" class="mt-2" @click="() => sticky.push({
        id: Math.max(...sticky.map(i => i.id)) + 1,
        width: '',
        height: '',
        price: '',
      })">新增</vs-button>
  </vx-card>

  <vx-card title="标签样式" class="mb-5">
    <vs-table :data="style">
      <template slot="thead">
        <vs-th style="width: 250px">
          形状
        </vs-th>
        <vs-th>
          图片样本
        </vs-th>
        <vs-th>
          操作
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td>
            <vs-input v-model="data[i].shape" />
          </vs-td>

          <vs-td>
            <div>
              <upload
                fileName="file"
                v-model="tr.picture"
                automatic
                text="上传"
                accept=".jpg,.png"
                action="/admin/v1/file/upload"
                :single-upload="true"
                :limit="1"
              />
            </div>
          </vs-td>
          <vs-td>
            <a class="cursor-pointer text-danger" @click="data.splice(i, 1)">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="primary" class="mt-2 mr-2" @click="savePrice">保存设置</vs-button>
    <vs-button type="border" color="primary" class="mt-2" @click="() => style.push({
        id: Math.max(...style.map(i => i.id)) + 1,
        shape: '',
        picture: '',
      })">新增</vs-button>
  </vx-card>

</div>
</template>
<script>
export default {
  $computed: ['dict.price.qr', 'dict.price.sticky', 'dict.price.style', 'dict.price.channelQr', 'dict.price.material', 'dict.price.qrExpire'],
  methods: {
    addQrPrice() {
      this.qr.push({
        min: '',
        max: '',
        price: '',
      })
    },
    removeQrPrice(i) {
      this.qr.splice(i, 1)
    },
    async savePrice() {
      const data = {
        qr: this.qr.filter(i => (i.min || i.max) && i.price),
        qrExpire: this.qrExpire.filter(i => i.name && i.price),
        channelQr: this.channelQr,
        sticky: this.sticky,
        style: this.style,
        material: this.material,
      }
      await this.$s.user.updatePrice(data).catch(err => {
        this.$notify({
          color: 'danger',
          title: '保存失败',
          text: '请检查你的输入是否有误'
        })
        throw err
      })

      this.$notify({
        title: '成功保存价格配置'
      })
    }
  }
}
</script>